var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconFilledStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C3C0ED2C-5150-4655-BD71-6E2290235487") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hub---Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CL---Hub---Tutor-Pop-up",
    transform: "translate(-308.000000, -645.000000)",
    fill: "#F6A11D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atoms-/-Icon-/-Filled-/-Star",
    transform: "translate(308.000000, 645.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5226108,2.81840035 L18.4958945,8.87628147 L25.1443591,9.84770788 C26.5370501,10.051198 27.093145,11.7721563 26.0853843,12.7599181 L21.2745101,17.475321 L22.4102034,24.1335766 C22.6481035,25.5283187 21.1922282,26.5919294 19.9465675,25.9334215 L14,22.7898196 L8.05343251,25.9334215 C6.80777175,26.5919294 5.35189652,25.5283187 5.58979655,24.1335766 L6.72548989,17.475321 L1.91461573,12.7599181 C0.906855007,11.7721563 1.46294986,10.051198 2.85564093,9.84770788 L9.5041055,8.87628147 L12.4773892,2.81840035 C13.1002196,1.5494221 14.8997804,1.5494221 15.5226108,2.81840035 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconFilledStar);
export default __webpack_public_path__ + "static/media/atoms-icon-filled-star.4760a82caf928565d9a14ab552dfd333.svg";
export { ForwardRef as ReactComponent };